import React, {useContext, useEffect, useState} from 'react';
import {Helmet} from 'rnd-helmet';
import {injectIntl} from "react-intl";
import Form from 'form';
import dispatchRerender from 'dispatchRerender';
import FormContext from "formContext";
import PrivacyPolicyModal from "@Components/PrivacyPolicyModal";
import axios from 'axios';
import { useDataLayer} from "dataLayerHelper";
import SubMenu from "@Components/SubMenu";
import useRegisterSubmitHandler from 'registerSubmitHandler';
import NoticeInPageCutover from "@Components/NoticeInPageCutover";

function Register({intl, match, staticContext}) {
  const headerTitleLeft = intl.formatMessage({id: "Register.Header.Title.Left"});
  const headerTitleRight = intl.formatMessage({id: "Register.Header.Title.Right"});
  const {setAdditionalData, formData, setFormData, currentStep, setErrors, additionalData} = useContext(FormContext);
  const [modalOpen, setModalOpen] = useState(false);
  const {handleRegisterSubmit} = useRegisterSubmitHandler();
  const cutoverMrndRegisterSettings = additionalData?.cutoverSettings?.myrandstad_register || {};

  const { locale } = intl;

  // Generate dataLayer for the page.
  useDataLayer(locale, staticContext);

  useEffect(() => {
    if (window.__ROUTE_DATA__) {
      delete window.__ROUTE_DATA__;
    }
    else {
      Promise.all([
        axios.get(`${process.env.REACT_APP_API_PREFIX}/job-categories-list`),
        axios.get(`${process.env.REACT_APP_API_PREFIX}/country-list`),
      ])
        .then(([jobCategoriesListResponse, countryListResponse]) => {
          setAdditionalData({
              specialisms: jobCategoriesListResponse?.data?.specialisms,
              masterLists: jobCategoriesListResponse?.data?.masterLists,
              countries: countryListResponse?.data?.countries
            }
          );
        });
    }

    dispatchRerender();
    setFormData([]);
  }, []);

  const handleChange = event => {
    let name = event.target.name;
    let value = event.target.value;
    if (event.target.type === 'checkbox') {
      let checkboxValue = event.target.value;
      if (typeof checkboxValue === 'string' && checkboxValue === 'true') {
        checkboxValue = true;
      }
      value = event.target.checked ? checkboxValue : null;
    }

    // Handle privacy checkbox.
    if (name === 'accept_privacy_policy' && process.env.REACT_APP_DISPLAY_MODAL_ON_REGISTER_PRIVACY_POLICY === 'true') {
      if (value) {
        setModalOpen(true);
        return;
      }
    }

    setFormData((prev) => {
      if (!prev[currentStep]) {
        prev[currentStep] = {};
      }
      prev[currentStep][name] = value;
      return {
        ...prev
      }
    });

    setErrors((prev) => {
      if (prev && prev.hasOwnProperty(name) && value) {
        delete prev[name];
      }

      return {
        ...prev,
      };
    });
  };

  const onAcceptConsent = () => {
    setFormData((prev) => {
      if (!prev[currentStep]) {
        prev[currentStep] = {};
      }
      prev[currentStep]['accept_privacy_policy'] = 'yes';
      return {
        ...prev
      }
    });
    setModalOpen(false);
  };

  const modalFooter = () => (
      <>
        <button onClick={onAcceptConsent} className="button button--m button--filled button--full-width">
          {intl.formatMessage({id: 'Register.Section.PersonalDataProcessing.Checkbox.PrivacyPolicy.Modal.Button'})}
        </button>
      </>
  );

  const handleSubmit = event => {
    event.preventDefault();
    handleRegisterSubmit();
  };

  const onCloseModal = () => {
    setModalOpen(false)
  };

  const renderModal = () => {
    if (!modalOpen) {
      return '';
    }
    return (
        <PrivacyPolicyModal
            title={intl.formatMessage({id: 'Register.Section.PersonalDataProcessing.Checkbox.PrivacyPolicy.Modal.Title'})}
            onClose={onCloseModal}
            footer={modalFooter()}
            footerDivider={false}
        />
    );
  };

  return (
    <>
      <Helmet>
        <title>{intl.formatMessage({id: 'Register.Meta.Title'})} | {intl.formatMessage({id: 'Page.Opcolabel.MetaTitle'})}</title>
        <meta name="description" content={intl.formatMessage({id: 'Register.Meta.Description'})} />
        <header className="header header--text bg-variant-brand-primary"/>
      </Helmet>
      <div className="header header--text bg-variant-brand-primary">
        <div className="header__wrapper wrapper">
          <SubMenu />
          <div className="header__content header__content--l content-block header__content--full-width has-breadcrumbs">
            <h1 className="content-block__title">
              <span className="content-block__title-top">{headerTitleLeft}</span>
              <span className="content-block__title-bottom text--emphasis">{headerTitleRight}</span>
            </h1>
          </div>
        </div>
      </div>
      <NoticeInPageCutover settings={cutoverMrndRegisterSettings} />
      <Form name='register' handleChange={handleChange} state={formData[currentStep]} handleSubmit={handleSubmit} hideGeneralErrors={true} />
      {process.env.REACT_APP_DISPLAY_MODAL_ON_REGISTER_PRIVACY_POLICY === 'true' && renderModal()}
    </>
  )
}

export default injectIntl(Register);
